'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tooltip/style/css.js
// module id = 77e7
// module chunks = 0